import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #081525 0%, #0f2540 35%, #1e4d80 65%, #2a5c38 100%)',
      padding: '24px',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 520 }}>

        {/* Número 404 */}
        <div style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'clamp(6rem, 20vw, 10rem)',
          fontWeight: 900,
          lineHeight: 1,
          letterSpacing: '-0.05em',
          background: 'linear-gradient(135deg, #5f9a3f 0%, #5a9ad4 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          marginBottom: '8px',
          userSelect: 'none',
        }}>
          404
        </div>

        {/* Logo */}
        <div style={{ marginBottom: 28 }}>
          <picture>
            <source srcSet="/logo3.webp" type="image/webp" />
            <img
              src="/logo3.webp"
              alt="Impacta M.A. SAS"
              style={{
                height: 64,
                width: 'auto',
                margin: '0 auto',
                filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.5)) brightness(1.15)',
              }}
            />
          </picture>
        </div>

        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'clamp(1.4rem, 4vw, 1.9rem)',
          fontWeight: 800,
          color: '#fff',
          marginBottom: 12,
          letterSpacing: '-0.02em',
        }}>
          Página no encontrada
        </h1>

        <p style={{
          fontSize: '1rem',
          color: 'rgba(255,255,255,0.6)',
          lineHeight: 1.75,
          marginBottom: 36,
        }}>
          La URL que ingresó no existe o fue movida.<br />
          Puede volver al inicio o explorar nuestros servicios.
        </p>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="btn btn--primary btn--lg">
            Ir al Inicio
          </Link>
          <Link to="/servicios/mineria" className="btn btn--ghost-white btn--lg">
            Ver Servicios
          </Link>
          <Link to="/contacto" className="btn btn--blue btn--lg">
            Contacto
          </Link>
        </div>

      </div>
    </div>
  );
}
